import { Model, AccessorsMutatorsDecorator, isInstanceOf } from "../../helpers";

import { Property } from "./property.model";
import { Role } from "./role.model";
import { CashDrawer } from "./cash-drawer.model";

import { isNullOrUndefined } from "util";

/**
 * @class User
 * @property {number} id
 * @property {string} name
 * @property {string} email
 * @property {string} role
 */
export class User extends Model {
  static get SUPER_ADMIN() {
    return "super_admin";
  }

  static get BUSINESS_OWNER() {
    return "business_owner";
  }

  static get MABEET_STAFF() {
    return "mabeet_staff";
  }

  static get PROPERTY_STAFF() {
    return "property_staff";
  }

  static get validationModel() {
    return {
      name: {
        label: "USER_NAME",
        commonLabel: "User Name",
      },
      email: {
        label: "EMAIL",
        messages: {
          email: "EMAIL_MUST_BE_IN_THE_FORMAT_EMAIL",
        },
      },
      propertyRole: {
        label: "ROLE",
      },
      mabeet_role: {
        label: "ROLE",
      },
    };
  }

  /**
   * @param {string} role
   * @returns {boolean}
   */
  hasBaseRole(role) {
    return this.role === role;
  }

  /**
   * @returns {boolean}
   */
  isSuperAdmin() {
    return this.hasBaseRole(this.constructor.SUPER_ADMIN);
  }

  isBusinessOwner() {
    return this.hasBaseRole(this.constructor.BUSINESS_OWNER);
  }

  isMabeetStaff() {
    return this.hasBaseRole(this.constructor.MABEET_STAFF);
  }

  isPropertyStaff() {
    return this.hasBaseRole(this.constructor.PROPERTY_STAFF);
  }

  isAdminRole() {
    return this.isSuperAdmin() || this.isMabeetStaff();
  }

  setProperties(value) {
    if (!Array.isArray(value) || !isInstanceOf(Property, value[0])) {
      value = Property.factory(value);
    }

    return value;
  }

  setRoles(attr) {
    if (angular.isUndefined(attr[0])) {
      return [];
    }
    return Role.factory(attr);
  }

  setOpenCashDrawers(value = []) {
    return value.map((drawer) =>
      drawer instanceof CashDrawer ? drawer : new CashDrawer(drawer)
    );
  }

  canByRoles(rolePermissions = {}) {
    if (!rolePermissions.hasOwnProperty(this.role)) {
      return true;
    }

    return rolePermissions[this.role];
  }

  canInPropertyByRoles(propertyId, rolePermissions = {}) {
    if (!rolePermissions.hasOwnProperty(this.role)) {
      return true;
    }

    const permission = rolePermissions[this.role];

    return this.canInProperty(propertyId, permission);
  }

  canPropertyUserInProperty(propertyId, permission) {
    if (this.role === User.SUPER_ADMIN || this.role === User.MABEET_STAFF) {
      return true;
    }

    return !!this.canInProperty(propertyId, permission);
  }

  canInProperty(propertyId, permission) {
    const permissions = this.userPermissions(parseInt(propertyId));
    return (
      isNullOrUndefined(permissions) ||
      !!(permissions || []).find((perm) => perm.name === permission)
    );
  }

  userPermissions(propertyId) {
    let permissions = null;

    if (!this.isSuperAdmin()) {
      if (this.isBusinessOwner()) {
        if (!this.hasActiveProperty(propertyId)) {
          permissions = []; //no permissions for foreign property, otherwise should be NULL (!important)
        }
      } else if (this.isMabeetStaff()) {
        permissions = this.roles.length > 0 ? this.roles[0].permissions : [];
      } else {
        permissions = this.hasActiveProperty(propertyId)
          ? this.roles.find((role) => role.property_id === propertyId)
              .permissions
          : [];
      }
    }

    return permissions;
  }

  hasActiveProperty(propertyId) {
    return this.active_properties.indexOf(propertyId) !== -1;
  }
}

AccessorsMutatorsDecorator(
  "id",
  "name",
  "email",
  "role",
  "roles",
  "propertyRole",
  "properties",
  "confirmed",
  "property_status",
  "activation_status",
  "status",
  "permissions",
  "account_id",
  "active_properties",
  "inproperties",
  "mabeet_role",
  "house_accounts",
  "open_cash_drawers",
  "user_status",
  "employee_number",
  "password",
  "password_confirmation",
  "activate_sms_auth",
  "phone_number",
  "phone_code"
)(User);



// WEBPACK FOOTER //
// ./src/pms-api/models/user.model.js